import React from "react";
import { translate } from "react-i18next";
import DataTable from "react-data-table-component";
// see: https://jbetancur.github.io/react-data-table-component/?path=/story/conditional-styling--conditional-cells
import { Checkbox, FontIcon } from "react-md";

import HalftimeChart1 from "./halftime_chart1";

const data = [
  {
    id: 1,
    title: "Conan the Barbarian",
    summary: "Orphaned boy Conan is enslaved after his village is destroyed...",
    year: "1982",
    image: "/assets/images/conan.jpeg"
  },
  {
    id: 2,
    title: "Shawshank Redemption",
    summary:
      "It tells the story of banker Andy Dufresne (Tim Robbins), who is sentenced to life in Shawshank State Penitentiary for the murder of his wife and her lover, despite his claims of innocence...",
    year: "1994",
    image: "/assets/images/shawshank.jpeg"
  }
];
const columns = [
  {
    name: "Image",
    sortable: false,
    width: "100px",
    cell: row => (
      <img
        src={process.env.PUBLIC_URL + row.image} 
        className="thumb-image"
        alt="{row.title}"
      />
    )
  },
  {
    name: "Title",
    sortable: true,
    cell: row => (
      <div>
        <div style={{ fontWeight: 700 }}>{row.title} - {row.year}</div>
        {row.summary}
      </div>
    )
  }
];

// The row data is composed into your custom expandable component via the data prop
const ExpanableComponent = ({ data }) => (
  <table>
    <tr>
      <td>
        <HalftimeChart1 name="name1" count="4" starttime="9" />
      </td>
    </tr>
  </table>
);

const handleChange = state => {
  // You can use setState or dispatch with something like Redux so we can use the retrieved data
  console.log("Selected Rows: ", state.selectedRows);
};

class ExpandableTable extends React.Component {
  constructor(props) {
    super();
  }
  render() {
    return (
      <div>
        <div className="container marketing no-banner">
          <div className="page-header">
            <div className="btn-toolbar pull-right">
              <div className="btn-group" />
            </div>
            <h3>Test expandable table</h3>
          </div>
          <HalftimeChart1 name="name1" count="4" starttime="9" />
          <DataTable
            title="Movies"
            columns={columns}
            data={data}
            //selectableRows
            //selectableRowsComponent={Checkbox}
            //selectableRowsComponentProps={{ inkDisabled: true }}
            sortIcon={<FontIcon>arrow_downward</FontIcon>}
            //onRowSelected={handleChange}
            expandableRows
            expandableRowsComponent={<ExpanableComponent />}
          />
        </div>
      </div>
    );
  }
}

export default translate()(ExpandableTable);
